/* ============================================================
   JOSY Délices — Template Blog Polyvalent
   Fichier : assets/josy-blog.js

   Fonctions :
   - Sommaire automatique
   - Sommaire repliable sur mobile
   - FAQ accessible
   - Tableaux responsives
   - Optimisation des images
   - Temps de lecture

   Dépendances :
   - aucune bibliothèque externe
   ============================================================ */

(function () {
  'use strict';


  /* ==========================================================
     UTILITAIRE — MOBILE
     ========================================================== */

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }


  /* ==========================================================
     SOMMAIRE
     Génération automatique depuis les H2 du corps de l'article

     Les titres portant :
     data-josy-toc-exclude

     sont volontairement exclus du sommaire.
     ========================================================== */

  function initSommaire() {
    const toc = document.querySelector('.josy-toc');

    if (!toc) return;


    const articleBody = document.querySelector('.josy-article-body');

    if (!articleBody) return;


    const headings = articleBody.querySelectorAll(
      'h2:not([data-josy-toc-exclude])'
    );


    if (headings.length === 0) {
      toc.style.display = 'none';
      return;
    }


    const list = toc.querySelector('.josy-toc__list');

    if (!list) return;


    /*
     * Sécurité :
     * vider la liste avant génération afin d'éviter
     * des doublons si le script est réinitialisé.
     */
    list.innerHTML = '';


    headings.forEach(function (heading, index) {

      /*
       * Ajouter un identifiant uniquement si le H2
       * n'en possède pas déjà un.
       */
      if (!heading.id) {
        heading.id = 'josy-section-' + index;
      }


      const li = document.createElement('li');
      const link = document.createElement('a');


      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();


      /*
       * Défilement fluide vers la section.
       */
      link.addEventListener('click', function (event) {
        event.preventDefault();

        const target = document.getElementById(heading.id);

        if (!target) return;


        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });


        /*
         * Accessibilité :
         * permettre au titre ciblé de recevoir temporairement
         * le focus après navigation depuis le sommaire.
         */
        target.setAttribute('tabindex', '-1');

        target.focus({
          preventScroll: true
        });


        /*
         * Sur mobile, refermer le sommaire après sélection.
         */
        const toggle = toc.querySelector('.josy-toc__toggle');

        if (toggle && isMobile()) {
          setTocExpanded(toggle, list, false);
        }
      });


      li.appendChild(link);
      list.appendChild(li);
    });


    const toggle = toc.querySelector('.josy-toc__toggle');


    /*
     * Si le sommaire n'est pas configuré comme repliable,
     * aucune logique supplémentaire n'est nécessaire.
     */
    if (!toggle) return;


    /*
     * État initial :
     * - mobile : fermé
     * - desktop : ouvert
     */
    setTocExpanded(toggle, list, !isMobile());


    toggle.addEventListener('click', function () {
      const currentlyExpanded =
        toggle.getAttribute('aria-expanded') === 'true';

      setTocExpanded(
        toggle,
        list,
        !currentlyExpanded
      );
    });


    /*
     * Adapter proprement l'état lors d'un changement
     * de largeur de fenêtre.
     */
    const mediaQuery = window.matchMedia('(max-width: 767px)');


    function handleViewportChange(event) {
      if (event.matches) {
        setTocExpanded(toggle, list, false);
      } else {
        setTocExpanded(toggle, list, true);
      }
    }


    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener(
        'change',
        handleViewportChange
      );
    } else if (typeof mediaQuery.addListener === 'function') {
      /*
       * Compatibilité anciens navigateurs.
       */
      mediaQuery.addListener(
        handleViewportChange
      );
    }
  }


  /* ==========================================================
     SOMMAIRE — GESTION DE L'ÉTAT OUVERT / FERMÉ
     ========================================================== */

  function setTocExpanded(toggle, list, expanded) {
    toggle.setAttribute(
      'aria-expanded',
      String(expanded)
    );


    list.hidden = !expanded;


    const chevron = toggle.querySelector(
      '.josy-toc__chevron'
    );


    if (chevron) {
      chevron.textContent = expanded ? '▴' : '▾';
    }
  }


  /* ==========================================================
     FAQ
     Accordéons accessibles et synchronisés
     ========================================================== */

  function initFaq() {
    const faqItems = document.querySelectorAll(
      '.josy-faq__item'
    );


    if (faqItems.length === 0) return;


    faqItems.forEach(function (item, index) {

      const button = item.querySelector(
        '.josy-faq__question'
      );

      const answer = item.querySelector(
        '.josy-faq__answer'
      );

      const icon = item.querySelector(
        '.josy-faq__icon'
      );


      if (!button || !answer) return;


      /*
       * Identifiants uniques pour aria-controls.
       */
      const answerId =
        'josy-faq-answer-' + index;


      answer.id = answerId;

      button.setAttribute(
        'aria-controls',
        answerId
      );


      /*
       * État initial.
       */
      const openByDefault =
        item.dataset.openDefault === 'true';


      setFaqItemState(
        button,
        answer,
        icon,
        openByDefault
      );


      /*
       * Le bouton HTML gère nativement :
       * - clic
       * - Entrée
       * - Espace
       *
       * Aucun gestionnaire clavier supplémentaire
       * n'est nécessaire.
       */
      button.addEventListener('click', function () {

        const isExpanded =
          button.getAttribute('aria-expanded') === 'true';


        /*
         * Fermer toutes les autres questions.
         */
        faqItems.forEach(function (otherItem) {

          if (otherItem === item) return;


          const otherButton =
            otherItem.querySelector(
              '.josy-faq__question'
            );

          const otherAnswer =
            otherItem.querySelector(
              '.josy-faq__answer'
            );

          const otherIcon =
            otherItem.querySelector(
              '.josy-faq__icon'
            );


          if (!otherButton || !otherAnswer) return;


          setFaqItemState(
            otherButton,
            otherAnswer,
            otherIcon,
            false
          );
        });


        /*
         * Ouvrir ou fermer la question sélectionnée.
         */
        setFaqItemState(
          button,
          answer,
          icon,
          !isExpanded
        );
      });
    });
  }


  /* ==========================================================
     FAQ — GESTION DE L'ÉTAT
     ========================================================== */

  function setFaqItemState(
    button,
    answer,
    icon,
    expanded
  ) {

    button.setAttribute(
      'aria-expanded',
      String(expanded)
    );


    /*
     * Synchroniser réellement l'attribut HTML hidden.
     */
    answer.hidden = !expanded;


    answer.classList.toggle(
      'is-open',
      expanded
    );


    if (icon) {
      icon.textContent = expanded ? '−' : '+';
    }
  }


  /* ==========================================================
     TABLEAUX
     Wrapper scrollable sur mobile
     ========================================================== */

  function initTables() {
    const articleBody = document.querySelector(
      '.josy-article-body'
    );


    if (!articleBody) return;


    const tables = articleBody.querySelectorAll(
      'table'
    );


    tables.forEach(function (table) {

      /*
       * Ne pas envelopper plusieurs fois
       * le même tableau.
       */
      if (
        table.parentElement &&
        table.parentElement.classList.contains(
          'josy-table-wrapper'
        )
      ) {
        return;
      }


      /*
       * Les tableaux natifs du composant Cartes
       * possèdent déjà leur propre wrapper.
       */
      if (
        table.closest('.josy-cards__table-wrap')
      ) {
        return;
      }


      const wrapper =
        document.createElement('div');


      wrapper.className =
        'josy-table-wrapper';


      table.parentNode.insertBefore(
        wrapper,
        table
      );


      wrapper.appendChild(table);
    });
  }


  /* ==========================================================
     IMAGES
     Chargement différé des images du corps
     ========================================================== */

  function initImages() {
    const articleBody = document.querySelector(
      '.josy-article-body'
    );


    if (!articleBody) return;


    const images =
      articleBody.querySelectorAll('img');


    images.forEach(function (img) {

      /*
       * Ne pas écraser un réglage déjà défini.
       */
      if (!img.hasAttribute('loading')) {
        img.setAttribute(
          'loading',
          'lazy'
        );
      }


      if (!img.hasAttribute('decoding')) {
        img.setAttribute(
          'decoding',
          'async'
        );
      }
    });
  }


  /* ==========================================================
     TEMPS DE LECTURE
     Calcul automatique
     ========================================================== */

  function initReadingTime() {
    const readingTimeEl =
      document.querySelector(
        '.josy-reading-time'
      );


    if (!readingTimeEl) return;


    const articleBody =
      document.querySelector(
        '.josy-article-body'
      );


    if (!articleBody) return;


    const text =
      articleBody.textContent || '';


    const cleanText =
      text.trim();


    if (!cleanText) {
      readingTimeEl.textContent =
        '1 min de lecture';

      return;
    }


    const wordCount =
      cleanText.split(/\s+/).length;


    /*
     * Vitesse moyenne :
     * 200 mots par minute.
     */
    const minutes =
      Math.max(
        1,
        Math.round(wordCount / 200)
      );


    readingTimeEl.textContent =
      minutes + ' min de lecture';
  }


  /* ==========================================================
     INITIALISATION
     ========================================================== */

  function init() {
    initSommaire();
    initFaq();
    initTables();
    initImages();
    initReadingTime();
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();
